<template>
  <a-modal title="案情通告" destroyOnClose :confirmLoading="loading" v-model="visible" @ok="handleOk">
    <a-form :form="form">
      <a-form-item label="案情通告">
        <a-textarea
          placeholder="案情通告"
          :rows="6"
          v-decorator="[
            'content',
            { rules: [{ required: true, message: '请填写案情通告' }] }
          ]"
        ></a-textarea>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import Api from "@/api";
import BaseModal from "@/components/base-modal";
export default {
  name: "NoticeModal",
  extends: BaseModal,
  data() {
    return {
      record: {},
      form: this.$form.createForm(this)
    };
  },
  methods: {
    show(record) {
      this.record = { ...record };
      this.open();
      this.$nextTick().then(() => {
        this.form.setFieldsValue({
          content: this.record.content
        });
      });
    },
    handleOk() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.loading = true;
          if (this.record.id) {
            //编辑
            try {
              await Api.post.updateNotice({
                id: this.record.id,
                ...values
              });
              this.close();
              this.$emit("edit");
            } catch (e) {}
          } else {
            //新增
            try {
              await Api.post.addAnnouncement({
                job_id: this.record.job_id,
                ...values
              });
              this.close();
              this.$emit("add");
            } catch (e) {}
          }
          this.loading = false;
        }
      });
    }
  }
};
</script>

